import { Field, FieldInformation, IconButton, Link, ZoomableImage } from '@components'
import type { CreateSetup } from '@here/api'
import { type FormStore, setValue } from '@modular-forms/solid'
import { ImageUpscale } from 'lucide-solid'
import { type Component, Show, createSignal, onMount } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import type { FormFieldType } from '.'
import { OptionalField } from '../../../../components/custom/OptionalDetails'
import { useImage } from '../../state/image'
import { useCreate } from '../state'
import { fieldInformation } from './fieldInformation'

export const ImageFormField: Component<{
	name:
		| 'image_macro'
		| 'image_pattern'
		| 'image_trend'
		| 'image_trigger'
		| 'image_volume_by_price'
		| 'image_time_stop'
	label: string
	FormField: FormFieldType
	form: FormStore<CreateSetup, undefined>
}> = (props) => {
	const [imageSource, setImageSource] = createSignal<string>()
	const { isEditing, newSetup, setupBeingEdited } = useService(useCreate)()
	const { getImage } = useService(useImage)()
	const isOptional =
		props.name === 'image_volume_by_price' || props.name === 'image_time_stop'

	onMount(() => {
		if (setupBeingEdited() && props.name) {
			setImageSource(setupBeingEdited()![props.name] ?? undefined)
		}
	})

	return (
		<props.FormField name={props.name}>
			{(field, formFieldProps) => (
				<Field.Root invalid={!!field.error}>
					<FieldInformation information={fieldInformation[props.name]}>
						{isOptional ? (
							<OptionalField>{props.label}</OptionalField>
						) : (
							<Field.Label>{props.label}</Field.Label>
						)}
					</FieldInformation>
					<Grid gridTemplateColumns="1fr auto">
						<Field.Input
							{...formFieldProps}
							value={field.value ?? ''}
							onChange={(val) => {
								// if the user is ediitng and they submit an empty image box, reset it to the original image src
								let value = val.target.value
								if (isEditing() && value === '') {
									value = imageSource() || ''
								}
								setValue(props.form, props.name, value)
							}}
							type="text"
						/>
						<ZoomableImage src={field.value!}>
							<IconButton
								type="button"
								disabled={!field.value && !field.error}
								variant="outline"
							>
								<ImageUpscale />
							</IconButton>
						</ZoomableImage>
					</Grid>
					{/* <Show when={isEditing() && newSetup()}>
						<Field.HelperText>
							<Show when={imageSource()}>
								<ZoomableImage src={getImage(imageSource()!)}>
									<Link>{imageSource()!}</Link>
								</ZoomableImage>
								<span> is currently saved. overwrite using the text field above</span>
							</Show>
						</Field.HelperText>
					</Show> */}
					<Field.ErrorText>{field.error && <div>{field.error}</div>}</Field.ErrorText>
				</Field.Root>
			)}
		</props.FormField>
	)
}
